/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable react/button-has-type */
/* eslint-disable react/self-closing-comp */
/* eslint-disable new-cap */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  Typography,
  Grid,
  Button,
  IconButton,
} from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import '../../shared/arial';
import Loader from 'react-loader-spinner';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import { Loading, generateWordDocument, exportXlsx } from '../../helpers/utils';
import examServices from '../../redux/services/examServices';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';

const getFormatedDate = (date) => {
  if (date === null) {
    return 'No date';
  }
  const hours = date.getHours();
  const minutes = date.getMinutes();

  return (`${date.toLocaleDateString('fr-EU')} - ${hours}h${minutes <= 9 ? '0' : ''}${minutes}`);
};

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ExamResults = ({ examIdentifier }) => {
  const [loadingState, setLoadingState] = useState(true);
  const [substring, setSubstring] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const [exam, setExam] = useState();
  const [totalPapers, setTotalPapers] = useState(0);
  const refTable = useRef();

  const [examData, setExamData] = useState([]);

  const classes = useStyles();

  const columns = [
    {
      title: 'Corrector',
      field: 'teacherId',
      width: '5%',
      render: (rowData) => {
        if (rowData.teacherId && rowData.teacherId.firstname) {
          return <Typography variant="caption">{`${rowData.teacherId.firstname} ${rowData.teacherId.name}`}</Typography>;
        }
        return <Typography variant="caption">No corrector assigned</Typography>;
      },
    },
    {
      title: 'Firstname',
      field: 'firstname',
      width: '5%',
    },
    {
      title: 'Name',
      field: 'name',
      width: '5%',
      defaultSort: 'asc',
    },
    {
      title: 'Answer',
      field: 'answer',
      width: '40%',
      render: (rowData) => (
        <>
          {rowData.answer && rowData.answer !== null
            ? (
              <CloudDownload
                style={{ marginRight: '5px', cursor: 'pointer' }}
                onClick={() => generateWordDocument(rowData.firstname, rowData.name, rowData.answer)}
                // color="primary"
              />
            )
            : <Typography variant="caption">n/a</Typography>}
        </>
      ),
    },
    {
      title: 'Problem',
      field: 'fetched',
      width: '5%',
    },
    {
      title: 'TimeStamp',
      field: 'created_at',
      width: '5%',
      render: (rowData) => `${getFormatedDate(rowData.created_at ? new Date(rowData.created_at) : null)}`,
    },
    {
      title: 'Grade',
      field: 'results.grade',
      render: ({ grade }) => {
        if (grade !== null && grade !== 'n/a' && exam.semester === 4) {
          return (
            <div className={classes.gradeDetails}>
              <div className={classes.resultRow}>
                <Typography className={classes.resultDetail}>
                  Compréhension globale :
                </Typography>
                <Typography className={classes.resultDetail}>
                  {grade.globalcomprehension || 0}
                  /5
                </Typography>
              </div>
              <div className={classes.resultRow}>
                <Typography className={classes.resultDetail}>
                  Vocabulaire médical :
                </Typography>
                <Typography className={classes.resultDetail}>
                  {grade.vocabulary || 0}
                  /10
                </Typography>
              </div>
              <div className={classes.resultRow}>
                <Typography className={classes.resultDetail}>
                  Syntaxe :
                </Typography>
                <Typography className={classes.resultDetail}>
                  {grade.syntax || 0}
                  /5
                </Typography>
              </div>
              <div className={classes.resultRow}>
                <Typography className={classes.totalGrade}>
                  Total :
                </Typography>
                <Typography className={classes.totalGrade}>
                  {(grade.syntax || 0) + (grade.vocabulary || 0) + (grade.globalcomprehension || 0)}
                  /20
                </Typography>
              </div>
            </div>
          );
        }
        if (grade !== null && grade !== 'n/a' && exam.semester === 5) {
          return (
            <div className={classes.gradeDetails}>
              <div className={classes.resultRow}>
                <Typography className={classes.resultDetail}>
                  Structure :
                </Typography>
                <Typography className={classes.resultDetail}>
                  {(grade.structure || 0)}
                  /3
                </Typography>
              </div>
              <div className={classes.resultRow}>
                <Typography className={classes.resultDetail}>
                  Contenu, idées générales :
                </Typography>
                <Typography className={classes.resultDetail}>
                  {(grade.content || 0)}
                  /5
                </Typography>
              </div>
              <div className={classes.resultRow}>
                <Typography className={classes.resultDetail}>
                  Vocabulaire médical :
                </Typography>
                <Typography className={classes.resultDetail}>
                  {(grade.vocabulary || 0)}
                  /2
                </Typography>
              </div>
              <div className={classes.resultRow}>
                <Typography className={classes.resultDetail}>
                  Syntaxe :
                </Typography>
                <Typography className={classes.resultDetail}>
                  {(grade.syntax || 0)}
                  /10
                </Typography>
              </div>
              <div className={classes.resultRow}>
                <Typography className={classes.totalGrade}>
                  Total :
                </Typography>
                <Typography className={classes.totalGrade}>
                  {(grade.syntax || 0) + (grade.vocabulary || 0) + (grade.structure || 0) + (grade.content || 0)}
                  /20
                </Typography>
              </div>
            </div>
          );
        }
        return <Typography variant="caption" style={{ color: '#8f8f8f' }}>No grade</Typography>;
      },
    },
    {
      title: 'Comment',
      field: 'results.comment',
      render: ({ comment }) => {
        if (comment && comment !== null && comment !== 'n/a') {
          return (
            <Typography style={{ color: '#757575', fontSize: '13px' }}>
              {comment}
            </Typography>
          );
        }
        return <Typography variant="caption" style={{ color: '#8f8f8f' }}>No comment</Typography>;
      },
    },
  ];

  const loadExamResults = async () => {
    setLoadingState(true);
    const fetchedData = [];
    const examStudents = [];
    const examRes = await elearningDetailsServices.getElearningDetailWithStudents(examIdentifier);
    if (examRes) {
      setExam(examRes.exam);
      if (examRes.students) {
        examRes.students.forEach((student) => {
          if (parseFloat(student.semester, 10) === parseFloat(examRes.exam.semester, 10)
          || parseFloat(student.semester, 10) - 1 === parseFloat(examRes.exam.semester, 10)
          || student.catchUp?.includes(parseFloat(examRes.exam.semester, 10))) {
            examStudents.push(student);
          }
        });
        let papers = 0;
        await Promise.all(examStudents.map(async (student) => {
          const examResultRes = await examServices.getExamPDFResults(student._id);
          let found = false;
          const studentObj = {
            created_at: null,
            userId: student._id,
            teacherId: 'n/a',
            firstname: student.firstname,
            name: student.name,
            answer: null,
            fetched: 'n/a',
            grade: 'n/a',
            comment: 'n/a',
          };
          if (examResultRes) {
            examResultRes.forEach((answer) => {
              if (!found && answer.examFile === examRes.exam.examSubject.examFile && answer.answer && answer.answer.length > 0) {
                found = true;
                studentObj.created_at = answer.created_at;
                studentObj.answer = answer.answer;
                studentObj.fetched = 'No problem';
              }
            });
            if (!found) {
              studentObj.answer = null;
              studentObj.fetched = 'No problem';
            }
          }
          examRes?.exam?.results?.forEach((result) => {
            if (result.userId === student._id && result.grade !== undefined) {
              studentObj.grade = result.grade;
              studentObj.teacherId = result.teacherId || 'No corrector assigned';
              const grades = Object.values(result.grade);
              const sum = grades.reduce((a, b) => a + b);
              if (sum > 0) papers += 1;
            }
            if (result.userId === student._id && result.comment && result.comment.length > 0) {
              studentObj.comment = result.comment;
            }
          });
          fetchedData.push(studentObj);
        }));
        setTotalPapers(papers);
        setExamData(fetchedData);
      }
    }
    setLoadingState(false);
  };

  useEffect(() => {
    loadExamResults();
  }, []);

  const handleRedirect = () => {
    setRedirect(true);
  };

  const handleAllPapers = () => {
    examData.forEach((studentResult) => {
      if (studentResult.answer.length > 0) {
        generateWordDocument(studentResult.firstname, studentResult.name, studentResult.answer);
      }
    });
  };

  if (redirect) {
    return <Redirect to="/list" />;
  }
  return (
    <div className={classes.root}>
      <Container className="dashboard">
        <Row>
          <Col md={1} style={{ marginBottom: '20px' }}>
            <IconButton
              aria-label="delete"
              onClick={() => handleRedirect()}
            >
              <ArrowBackIcon />
            </IconButton>
          </Col>
          <Col md={10} style={{ marginBottom: '20px' }}>
            {(loadingState === false && (exam.semester <= 5 && exam.semester >= 3) && examData && examData.length > 0)
              && <Button variant="contained" color="primary" style={{ marginBottom: '25px', width: '30%', marginLeft: '35%' }} onClick={handleAllPapers}>Télécharger toute les copies</Button>}
          </Col>
        </Row>
      </Container>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          {
            loadingState === false
              ? (
                <MaterialTable
                  style={{ width: '100%' }}
                  title={`Results for ${exam?.name ? exam.name.replace(/\b(level 1|level 2)\b\s*$/i, '') : ''} - Total papers: ${totalPapers}`}
                  columns={columns}
                  isLoading={loadingState}
                  components={{
                    OverlayLoading: () => (<Loading />),
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: loadingState ? '' : 'No results to display',
                    },
                  }}
                  tableRef={refTable}
                  data={examData}
                  options={{
                    search: true,
                    exportButton: {
                      csv: true,
                      pdf: false,
                    },
                    exportCsv: () => {
                      const examObj = { ...exam } || null;
                      const finalResults = [];
                      const resultsArr = [...examData];
                      resultsArr.sort((a, b) => a.name > b.name);
                      resultsArr.forEach((elem) => {
                        const item = { ...elem };
                        if (exam.anonymous) {
                          item.Corrector = item.teacherId;
                        } else {
                          item.Corrector = 'n/a';
                        }
                        if (exam.anonymous) {
                          item['Numéro'] = item.number;
                        } else {
                          item.Nom = item.name;
                          item['Prénom'] = item.firstname;
                        }
                        if (item.grade !== 'No grade' && item.grade !== undefined) {
                          if (examObj.semester === 4) {
                            item['Vocabulaire et termes médicaux (/10)'] = item.grade.vocabulary;
                            item['Compréhension globale (/5)'] = item.grade.globalcomprehension;
                            item['Syntaxe (/5)'] = item.grade.syntax;
                            item['Note (/20)'] = parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.globalcomprehension, 10) + parseFloat(item.grade.syntax, 10);
                          } else if (examObj.semester === 5) {
                            item['Vocabulaire et termes médicaux (/10)'] = item.grade.vocabulary;
                            item['Structure (/3)'] = item.grade.structure;
                            item['Contenu, qualité et idées globales (/5)'] = item.grade.content;
                            item['Syntaxe (/2)'] = item.grade.syntax;
                            item['Note (/20)'] = parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.structure, 10) + parseFloat(item.grade.content, 10) + parseFloat(item.grade.syntax, 10);
                          } else if (examObj.semester === 3 && (examObj.durations === 60 || examObj.duration === '1h ' || examObj.duration === 60)) {
                            item['Vocabulaire et termes médicaux (/60)'] = item.grade.vocabulary;
                            item['Compréhension écrite (/20)'] = item.grade.readingcomprehension;
                            item['Score (/80)'] = parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.readingcomprehension, 10);
                            item['Note (/20)'] = ((parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.readingcomprehension, 10)) / 80) * 20;
                          } else if (examObj.semester === 3 && (examObj.durations === 90 || examObj.duration === '1h 30min' || examObj.duration === 90)) {
                            item['Vocabulaire et termes médicaux (/80)'] = item.grade.vocabulary;
                            item['Compréhension écrite (/20)'] = item.grade.readingcomprehension;
                            item['Score (/100)'] = parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.readingcomprehension, 10);
                            item['Note (/20)'] = ((parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.readingcomprehension, 10)) / 100) * 20;
                          }
                        }
                        if ((examObj.semester === 6 && (exam.examModality === 'Voie postale' || exam.examModality === 'Sur table'))) {
                          // searching for grade since it's not in the base obj of the student
                          exam?.results?.forEach((result) => {
                            if (result.userId === item.userId && result.grade !== undefined) {
                              item['Méthodologie (/5)'] = result.grade.methodology;
                              item['Mots clé (/2.5)'] = result.grade.keywords;
                              item['Vocabulaire et termes médicaux (/10)'] = result.grade.vocabulary;
                              item['Syntaxe (/2.5)'] = result.grade.syntax;
                              item['Note (/20)'] = parseFloat(result.grade.methodology, 10) + parseFloat(result.grade.keywords, 10) + parseFloat(result.grade.vocabulary, 10) + parseFloat(result.grade.syntax, 10);
                            }
                          });
                        }
                        if (examObj.semester === 4) {
                          exam?.results?.forEach((result) => {
                            if (result.userId === item.userId && result.grade !== undefined) {
                              item['Vocabulaire et termes médicaux (/10)'] = result.grade.vocabulary;
                              item['Compréhension globale (/5)'] = result.grade.globalcomprehension;
                              item['Syntaxe (/5)'] = result.grade.syntax;
                              item['Note (/20)'] = parseFloat(result.grade.vocabulary, 10) + parseFloat(result.grade.globalcomprehension, 10) + parseFloat(result.grade.syntax, 10);
                            }
                          });
                        }
                        if (examObj.semester === 5) {
                          exam?.results?.forEach((result) => {
                            if (result.userId === item.userId && result.grade !== undefined) {
                              item['Vocabulaire et termes médicaux (/10)'] = result.grade.vocabulary;
                              item['Structure (/3)'] = result.grade.structure;
                              item['Contenu, qualité et idées globales (/5)'] = result.grade.content;
                              item['Syntaxe (/2)'] = result.grade.syntax;
                              item['Note (/20)'] = parseFloat(result.grade.vocabulary, 10) + parseFloat(result.grade.structure, 10) + parseFloat(result.grade.content, 10) + parseFloat(result.grade.syntax, 10);
                            }
                          });
                        }
                        if (item.grade === undefined) {
                          item.grade = 'n/a';
                        }
                        if (exam && exam !== null) {
                          exam.results.forEach((result) => {
                            if (result.userId === item.userId) {
                              item.Commentaire = result.comment;
                            }
                          });
                        }
                        delete item.tableData;
                        delete item.comment;
                        delete item.grade;
                        delete item.name;
                        delete item.firstname;
                        delete item.userId;
                        delete item.file;
                        delete item.created_at;
                        delete item.groupId;
                        delete item.answer;
                        delete item.fetched;
                        delete item.state;
                        delete item.testId;
                        delete item.total;
                        delete item.groupId;
                        delete item.note;
                        delete item.number;
                        finalResults.push(item);
                      });
                      const today = new Date();
                      const sortedArr = finalResults.sort((a, b) => ((
                        a.Nom > b.Nom)
                        ? 1
                        : ((b.Nom > a.Nom)
                          ? -1
                          : 0)
                      ));
                      exportXlsx(sortedArr, `${examObj.name.replace(/\b(level 1|level 2)\b\s*$/i, '')}_${today.getDate()}/${today.getMonth() + 1}`);
                    },
                    exportAllData: true,
                    pageSize: examData.length,
                    sorting: true,
                    tableLayout: 'auto',
                  }}
                  onRowClick={(e, data) => {
                    if (substring !== data.userId) {
                      setSubstring(data.userId);
                    } else {
                      setSubstring(null);
                    }
                  }}
                />
              )
              : <Loader type="TailSpin" color="#3F51B5" height={40} width={40} />
          }
        </Grid>
      </Grid>
    </div>
  );
};

export default ExamResults;
